import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getCustomFieldOptions = {
  name: "getCustomFieldOptions" as const,
  input: z.object({ customFieldId: zExt.objectId() }),

  output: z.object({
    name: z.string(),
    options: z.array(z.object({ id: z.string(), name: z.string() })),
  }),
};
